// extracted by mini-css-extract-plugin
module.exports = {"SingleElement":"SingleElement_SingleElement__i2xm1"};